/* globals dataLayer, adobe */
(function (window, angular, undefined) {
    angular.module('formApp')
        .controller('stepOneTwoCtrl', ['$scope', '$rootScope', '$q', 'FormService', 'updateHeader', '$state', '$log', 'formData', 'scrollToPoint', '$timeout', 'errorHandler', 'LoadingInterceptor', '$stateParams', '$location', 'sessionService', 'dataLayerService', '$window',
            function ($scope, $rootScope, $q, formService, updateHeader, $state, $log, formData, scrollToPoint, $timeout, errorHandler, loadingInterceptor, $stateParams, $location, sessionService, dataLayerService, $window) {

                $scope.combined2 = sessionStorage.getItem('journeyType') === 'combined2';
                $scope.yourDetails = { open: !!formData.aboutYou.title };

                //1
                sessionService.start();
                
                if (sessionStorage.getItem('eQuote') || sessionStorage.getItem('eCoverNote')) {
                    sessionStorage.removeItem('formStateUri');
                    sessionStorage.removeItem('retrieveQuote');
                    sessionStorage.removeItem('eQuote');
                    sessionStorage.removeItem('eCoverNote');
                    sessionStorage.removeItem('campaign');
                    sessionStorage.removeItem('brav');
                    $scope.$parent.campaign = '';
                    $scope.$parent.brav = '';
                }
                if ($state.params.type === 'topNav') {
                    var navMethod = $state.params.type;
                }

                // This will only execute if we have come from step 5
                if ($state.params.petToEdit) {
                    $timeout(function () {
                        var petToSCrollTo = "petAnchor" + $state.params.petToEdit;

                        scrollToPoint.scrollTo(petToSCrollTo, 20, 'id');
                    });
                }
                $rootScope.firstPetNameSet = false;

                $scope.petNameQs = function (index) {

                    if($scope.formData.pets.length > 1){
                        $rootScope.singlePetQs = false;
                        var i;
                        for (i = 0; i < $scope.formData.pets.length; i++) {
                            var multiPetName = $scope.formData.pets[i].details.name;
             
                            if ($scope.formData.pets[i].details.name && index.$index === i){
                                $rootScope.firstPetNameSet  = true;
                                $rootScope.firstPetName = $scope.formData.pets[i].details.name;
                                return multiPetName;
                            }  
                        }

                    }
                    else{
                        $rootScope.singlePetQs = true;
                        var petName = $scope.formData.pets[0].details.name;
             
                        if ($scope.formData.pets[0].details.name && index.$index === 0){
                            $rootScope.firstPetNameSet  = true;
                            $rootScope.firstPetName  = petName;
                            return petName;
                        }
                        else if ($location.search().petName && index.$index === 0){
                                $rootScope.firstPetNameSet  = true;
                                 $rootScope.firstPetName = $location.search().petName;
                                return $location.search().petName;
                        }
                        else{
          
                            return '';
                        }

                    }
               
                };

                $scope.$watch('formData.pets[0].details.name', function() {
                    if ($scope.formData.pets[0].details && $scope.formData.pets[0].details.name) {
                        $rootScope.firstPetName = $scope.formData.pets[0].details.name;
                        $rootScope.firstPetNameSet  = true;
                    } else {
                        $rootScope.firstPetName = '';
                        $rootScope.firstPetNameSet  = false;
                    }
                });

                $scope.$watch('formData.pets[1].details', function(newVal, oldVal) {
                    if (newVal) {
                        $rootScope.singlePetQs = false;
                    } else {
                        $rootScope.singlePetQs = true;
                    }
                });

                sessionStorage.setItem('currentRefreshState', 'step-1-2');
                sessionStorage.setItem('journey', 'combined');
                $rootScope.mainJourney = false;
                $rootScope.journeyClass = 'combined';

                $scope.$watch('gatewayReady', function () {
                    if ($scope.gatewayReady === true && sessionStorage.getItem('formStateUri')) {
                        formService.setApplicationId(sessionStorage.getItem('formStateUri'));
                        refresh().then(function (response) {
                            $scope.formData.pets = response.data.application.pets;
                            $scope.formData.cover = response.data.application.cover;
                            $scope.formData.aboutYou = response.data.application.aboutYou || $scope.formData.aboutYou;
                            $scope.gaPetPostition = 1;
                            // if the start date is in the past force the user to reselect
                            if (moment($scope.formData.cover.startDate).isBefore(moment().format('YYYY-MM-DD'))) {
                                delete $scope.formData.cover.startDate;
                                $timeout(function () {
                                    scrollToPoint.scrollTo("coverStartDaterelday", 20, 'id');
                                    $scope.submitted = true;
                                });
                            }
                        });
                    }

                    function refresh() {
                        return formService.getApplication();
                    }
                });

                $scope.coverStartDateMin = moment().format('YYYY-MM-DD');
                $scope.coverStartDateMax = moment().add(1, 'month').format('YYYY-MM-DD');
                $scope.dobDateMin = moment().format('YYYY-MM-DD');
                $scope.dobDateMax = moment().subtract(16, 'year').startOf('year').format('YYYY-MM-DD');

                $scope.formData = formData;

                $scope.hideDiscount = sessionStorage.getItem('hideDiscount');

                if (!sessionStorage.getItem('formStateUri')) {
                    var petValue = $location.search().petvalue;
                    if (['dog', 'cat', 'rabbit'].indexOf(petValue) !== -1) {
                        $scope.formData.pets[0].type = petValue;
                        updateHeader.petType = petValue;
                    }
                }

                $scope.setCoverDateInit = function () {
                    $scope.formData.cover.startDate = $scope.formData.cover.startDate || $scope.coverStartDateMin;
                };

                $scope.isFutureDate = function (date) {
                    return date && moment(date).isAfter(moment().format('YYYY-MM-DD'));
                };

                $scope.updateHeader = function (petType) {
                    updateHeader.petType = petType;

                    if ($scope.formData.pets.length > 1) {
                        updateHeader.petType = 'multipet';
                    }
                };
                $scope.addPet = function () {
                    $scope.gaPetPostition = $scope.gaPetPostition + 1;
                    if ($scope.formData.pets.length < 5) {
                        $scope.formData.pets.push({});
                    }
                    $timeout(function () {
                        var petLength = $scope.formData.pets.length - 1,
                            petID = 'pettype-petTypeDog[' + petLength + ']',
                            focusPetSelect = document.getElementById(petID);
                        focusPetSelect.focus();
                    });
                };
                function processPetDetails() {
                    var promises = [];
                    $scope.formData.pets.forEach(function (pet) {
                        if (pet.uri) {
                            promises.push(formService.updatePet(pet, pet.uri, $scope.insuranceApplicationUri));
                        } else {
                            promises.push(formService.postPet(pet, $scope.insuranceApplicationUri).then(function success(response, status) {
                                if (response.data && response.data.uri) {
                                    pet.uri = response.data.uri.substr(-8) === '/details' ? response.data.uri.slice(0, -8) : response.data.uri;
                                }
                            }));
                        }
                    });
                    return promises;
                }

                //2

                function returnPetAge(dob) {
                    var a = moment();
                    var b = moment(dob);


                    var years = a.diff(b, 'year');
                    b.add(years, 'years');

                    var months = a.diff(b, 'months');
                    b.add(months, 'months');

                    var days = a.diff(b, 'days');

                    var petAge =
                    {
                        "years": years,
                        "months": months,
                        "days": days
                    };

                    return petAge;

                }
                function hasValidAddressFieldLengths() {

                    var isValid = true;
                    angular.forEach(['houseNameOrNumber', 'street', 'addressLine2', 'town', 'county'], function (key, value) {
                        if ($scope.schema.application.aboutYou[key].required && !$scope.formData.aboutYou[key]) {
                            isValid = false;
                        }
                        if ($scope.schema.application.aboutYou[key].hasOwnProperty('constraints')) {
                            var maxlength = $scope.schema.application.aboutYou[key].constraints.filter(function (constraint) {
                                return constraint.type === 'length';
                            });
                            if (maxlength.length > 0 && $scope.formData.aboutYou[key] && $scope.formData.aboutYou[key].length > maxlength[0].max) {
                                isValid = false;
                            }
                        }
                    });
                    return isValid;
                }
                $scope.ownerDobDateMin = moment().subtract(18, 'year').format('YYYY-MM-DD');
                $scope.ownerDobDateMax = moment().subtract(120, 'year').format('YYYY-MM-DD');


                $scope.formData = formData;
                $scope.address = {
                    show: false
                };

                $scope.hideDiscount = sessionStorage.getItem('hideDiscount');
                //1-2
                $scope.submit = function(e) {
                    loadingInterceptor.incrementRequests();
                    e.preventDefault();
                    var petIndex = 0,
                        params = {};

                    if ($scope.campaign) {
                        params.campaign = $scope.campaign;
                    }
                    if ($scope.brav) {
                        params.brav = $scope.brav;
                    }

                    formService.getApplicationId(params).then(function(response) {
                        formService.setApplicationId(response.applicationId);
                        processForm(petIndex);
                    }).catch(function(e) {
                        errorHandler.reportErrors(e, 'redirect', 'tech');
                    });
                };
                $scope.overSixMonths = function (pet){
                    if (pet.details !== undefined && pet.details.dateOfBirth !== undefined) {
                        var dob = pet.details.dateOfBirth;
                        var diffMonths = moment().diff(moment(dob), 'months', true);
                        if (diffMonths > 6) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                };

                function processForm(index) {

                    if (index === $scope.formData.pets.length) {
                        formService.postCover($scope.formData.cover).then(function success(response) {
                            formService.postAboutYou($scope.formData.aboutYou).then(function() {
                                loadingInterceptor.decrementRequests();
                               $state.go('step-3', { forward: true });
                            }).catch(function(error) {
                               errorHandler.reportErrors(error,'redirect','tech');
                            }); 

                        }, function failure(e) {
                            errorHandler.reportErrors(e, 'redirect', 'tech');
                        });
                    } else {
                        var pet = $scope.formData.pets[index];
                        pet.details['spayedOrNeutered'] = 'N';
                        if (pet.uri) {
                            formService.updatePetType(pet).then(function success() {
                                return formService.updatePet(pet);
                            }).then(function() {
                                processForm(index + 1);
                            }).catch(function(e) {
                                errorHandler.reportErrors(e, 'redirect', 'tech', 'args');
                            });
                        } else {
                            formService.postPet(pet).then(function success(response, status) {
                                if (response.data && response.data.uri) {
                                    pet.uri = response.data.uri.substr(-8) === '/details' ? response.data.uri.slice(0, -8) : response.data.uri;
                                    processForm(index + 1);
                                }
                            }, function failure(e) {
                                errorHandler.reportErrors(e, 'redirect', 'tech');
                            });
                        }
                    }
                }

                function reportErrors(fault) {
                    if (fault.message) {
                        $log.error(fault.message);
                    } else {
                        $log.error(JSON.stringify(fault));
                    }
                }

            }
        ]);
})(window, window.angular); 